module.exports = __webpack_public_path__ + "static/media/mobilier-ext.34388795.svg";